export const environment = {
  apiConnectURL: "https://api-hml.fgc.org.br/app/backoffice",
  apiConnectAppUrl: "",
  hostname: "www.portal-dev.fgc.local",
  production: false,
  cognito: {
    UserPoolId: "us-east-1_H3bPKSAM5",
    ClientId: "2vlr2qu9ilp0c7ujh0qmcb17pk",
  },
};
